import React from 'react';
import Map from '../map2';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {theme} from '../../styles';
import fetchUser from '../../utils/gaia/fetchUser';
import useSyncPromise from '../../utils/react/useSyncPromise';

interface MapGalleryLayerType extends LayerType {
    name: string;
    default_opacity: number;
}

interface MapGalleryPreviewProps {
    source: MapGalleryLayerType;
    baseSource: MapGalleryLayerType;
    bounds: mapboxgl.LngLatBoundsLike;
}

export default function MapGalleryPreview({source, baseSource, bounds}: MapGalleryPreviewProps) {
    let validMapforPreview;
    let alertText;
    const [user] = useSyncPromise(fetchUser());
    const units = user ? user.unitSystem : 'imperial';

    let baseSourceKey: string = baseSource && baseSource.uniqueTilecacheKey;
    const seasonalOverlays = ['Precip', 'Snow', 'Current'];
    const nonValidMaps = ['FranceIGNTopoPaid'];
    for (let i = 0; i < seasonalOverlays.length; i++) {
        if (source.name.includes(seasonalOverlays[i])) {
            //bounds for the continental united states
            bounds = [-124.791110603, 30.91619, -66.96466, 49.3577635769];
            alertText = 'Conditions may not be present on live updating maps. Try zooming in.';
            if (units === 'metric') {
                baseSourceKey = 'GaiaTopoRasterMeters';
            } else {
                baseSourceKey = 'GaiaTopoRasterFeet';
            }
        }
    }

    const layers = [
        ...(baseSourceKey ? [{type: baseSourceKey, opacity: 1}] : []),
        {type: source.uniqueTilecacheKey, opacity: source.default_opacity || 1}
    ];

    if (source.tileUrlPreview) {
        alertText = 'This map preview limits the area you can view.';
    }

    if (nonValidMaps.indexOf(source.uniqueTilecacheKey) < 0) {
        validMapforPreview = (
            <div style={{
                margin: '0 auto',
                marginBottom: 20,
                height: 300,
                width: '100%',
                textAlign: 'left',
                maxWidth: 1200
            }}>
                <Map
                    preview
                    showGeolocateControl={false}
                    layers={layers}
                    // @ts-ignore Remove when mapboxgl type definitions are available for 0.52.0
                    options={{bounds}}
                    style={{height: 300, width: '100%'}}
                    // Prevent double tapping on map from zooming entire page on mobile #3338
                    onTouchEnd={event => event.originalEvent.preventDefault()}
                />
            </div>
        );
    } else {
        validMapforPreview = <div className='alert alert-info' style={{borderRadius: 0}}>
            Sorry, no map preview available! You can view this map with a
            <a style={{color: '#14BCBD'}} href="/premium/">Premium Membership.</a>
        </div>;
    }
    return (<MuiThemeProvider theme={theme}>
        {validMapforPreview}
        {alertText && <div className='alert alert-info' style={{borderRadius: 0}}>{alertText}</div>}
    </MuiThemeProvider>
    );
}
